import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InstancesMgmtComponent} from 'src/app/main/instances-mgmt/instances-mgmt.component';
import { InstancesDetailsComponent } from './instances-details/instances-details.component';

const routes: Routes = [
  {
    path: '',
    component: InstancesMgmtComponent,
    title: 'Environment'
  },
  {
    path: ':instanceId',
    component: InstancesDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InstancesMgmtRoutingModule {
}
